import { Injectable } from "@angular/core";
import { Article } from "../models/article/article";
import { ArticleListAdapter } from "./article-list.adapter";
import { ArticleBlockAdapter } from "./article-block.adapter";
import { MediaAdapter } from "@core/adapters/media.adapter";
import { ArticleListItem } from "../models/article/article-list-item";

@Injectable({providedIn: 'root'})
export class ArticleAdapter {
  constructor(private articleListAdapter:ArticleListAdapter, private articleBlockAdapter:ArticleBlockAdapter, private mediaAdapter:MediaAdapter){}
  adapt(item: any): Article {
    return {
      id: item.id,
      name: item.title,
      slug: item.slug,
      articleNumber: item.number ??'',
      articleId: item.id,
      updatedAt : item.updatedAt,
      parentId: item.parent?item.parent.split('/').pop():'',
      contentBlocks: (item.content ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      summaryBlocks: (item.summary ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      relatedArticles : (item.relatedArticles?? []).map((x:any) => this.articleListAdapter.adapt(x)),
      children : (item.children?? []).map((x:any) => this.articleListAdapter.adapt(x)),
      currentVersion: 'v' + (item.version ?? "1"),
      hasPreviousVersion: item.previousVersion ?? false,
      previousContentBlocks: (item.previousContent ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      previousSummaryBlocks: (item.previousSummary ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      attachments: (item.attachments ??[]).map((m:any) => this.mediaAdapter.adaptFromArticle(m)),
      nestingNumber:item.nestingNumber ??''
    };
  }

  adaptFromManualArticle(ma: any): Article {
    const item = ma.article;
    const relatedArticles = (item.relatedArticles?? []).filter((x:any) => x["@type"] == "ManualArticle");   
    return {
      id: ma.id,
      name: ma.title,
      slug:ma.slug,
      articleNumber: ma.number ??'',
      nestingNumber:ma.nestingNumber ??'',
      children : (ma.children?? []).map((x:any) => this.articleListAdapter.adaptFromManualArticle(x)),
      
      articleId: item.id,
      updatedAt : item.updatedAt,
      parentId: item.parent?item.parent.split('/').pop():'',
      contentBlocks: (item.content ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      summaryBlocks: (item.summary ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      relatedArticles : relatedArticles.map((x:any) => {
        return { id: x['@id'].split('/').pop(), name:x.title, articleNumber: x.number, nestingNumber:x.nestingNumber, language: x.article.language.split('/').pop(), slug:x.article.slug  } as ArticleListItem}),
      currentVersion: 'v' + (item.version ?? "1"),
      hasPreviousVersion: item.previousVersion ?? false,
      previousContentBlocks: (item.previousContent ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      previousSummaryBlocks: (item.previousSummary ?? []).map((x:any,i:number) => this.articleBlockAdapter.adapt(x,i)),
      attachments: (item.attachments ??[]).map((m:any) => this.mediaAdapter.adaptFromArticle(m)),
    };
  }
}
